<template>
  <Dialog
    v-model:visible="visible"
    :style="{ width: '75vw' }"
    :modal="true"
    :closable="false"
  >
    <template #header>
      <h1>Termo de uso e Política de privacidade Web Farm</h1>
    </template>

    <UseTermText></UseTermText>

    <template #footer>
      <div class="p-grid p-mt-3">
        <div class="p-col-12">
          <div class="p-field-checkbox">
            <Checkbox
              name="termsAccepted"
              v-model="termsAccepted"
              :binary="true"
            />
            <label for="termsAccepted">
              Aceito os termos e condições gerais de uso do sistema Web Farm
            </label>
          </div>
          <div class="p-field-checkbox">
            <Checkbox
              name="privacyAccepted"
              v-model="privacyAccepted"
              :binary="true"
            />
            <label for="privacyAccepted">
              Aceito a política de privacidade do sistema Web Farm
            </label>
          </div>
        </div>
        <div class="p-col-12">
          <Button
            label="Cancelar"
            class="p-button-outlined p-mr-2"
            @click="cancel()"
          />
          <AppButton
            label="Aceito"
            @click="accept()"
            :disabled="!(termsAccepted && privacyAccepted) || loading"
            :loading="loading"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import UseTermText from './UseTermText';
import { UserApi } from '../../../services/api';

export default {
  name: 'UseTermDialog',
  components: {
    UseTermText,
  },
  computed: {
    ...mapFields('app', ['user']),
  },
  data() {
    return {
      lastTermUpdate: '2021-02-07',
      visible: false,
      termsAccepted: false,
      privacyAccepted: false,
      loading: false,
    };
  },
  created() {
    if (!this.user.accountId) {
      return;
    }
    const lastTermUpdate = this.$dayjs(this.lastTermUpdate);

    const isPrivacyAccepted = this.user.privacyAcceptedAt
      ? this.$dayjs(this.user.privacyAcceptedAt).isAfter(lastTermUpdate)
      : false;

    const isTermsAccepted = this.user.termsAcceptedAt
      ? this.$dayjs(this.user.termsAcceptedAt).isAfter(lastTermUpdate)
      : false;

    this.visible = !(isPrivacyAccepted && isTermsAccepted);
  },
  methods: {
    ...mapActions('app', ['logout', 'setUser']),
    async accept() {
      try {
        this.loading = true;
        const data = {
          privacyAcceptedAt: new Date(),
          termsAcceptedAt: new Date(),
        };
        await UserApi.updateMe(data);
        this.user.privacyAcceptedAt = data.privacyAcceptedAt;
        this.user.termsAcceptedAt = data.termsAcceptedAt;
        this.setUser(this.user);
        this.visible = false;
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.logout();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style>
</style>